import React, { useState } from 'react'
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from './Component/Navbar';
import Home from './Component/Home';
import NoteState from './context/note/NoteState.js';
import Alert from './Component/Alert.js';
import Login from './Component/Login.js';
import Signup from './Component/Signup.js';
import Admin from './Component/Admin.js';
import LoadingBar from 'react-top-loading-bar'
import LandingPage from './Component/LandingPage.js';
import Footer from './Component/Footer.js';

function App() {
  const [alert, setAlert] = useState(null)

  let URI = process.env.REACT_APP_BACKEND_URI

  const showAlert = (type, message) => {
    setAlert({
      msg: message,
      typ: type
    })

    setTimeout(() => {
      setAlert(null)
    }, 3000);
  }

  const [progress, setProgress] = useState(0)

  return (
    <>
      <NoteState URI={URI} >
        <Router>
          <div className='ibm-plex-mono-medium'>
            <Navbar showAlert={showAlert} URI={URI} />
            <LoadingBar color="#f11946" progress={progress} onLoaderFinished={() => setProgress(0)} />
            <Alert alert={alert} URI={URI} />
            <Routes>

              <Route exact path="/" element={<LandingPage showAlert={showAlert} />} URI={URI} />
              <Route exact path="/home" element={<Home showAlert={showAlert} URI={URI} />} />
              <Route exact path="/login" element={<Login showAlert={showAlert} URI={URI} progress={progress} setProgress={setProgress} />} />
              <Route exact path="/signup" element={<Signup showAlert={showAlert} URI={URI} progress={progress} setProgress={setProgress} />} />
              <Route exact path="/admin" element={<Admin showAlert={showAlert} URI={URI} />} />

            </Routes>
            <Footer />
          </div>
        </Router>

      </NoteState>
    </>
  )
}

export default App
